import * as React from 'react';

import PlatformCam32 from './PlatformCam32';

export const platformCam32 = () => <PlatformCam32 />;

export default {
    title: 'Icon/Content/PlatformCam32',
    component: PlatformCam32,
    parameters: {
        notes: "`import PlatformCam32 from 'box-ui-elements/es/icon/content/PlatformCam32';`",
    },
};
